import React from "react";

const UnderMaintenance = ({ backgroundImage = "" }) => {
  const containerStyle = {
    ...styles.container,
    ...(backgroundImage && {
      backgroundImage: `url("${backgroundImage}")`,
    }),
  };

  return (
    <main style={containerStyle}>
      <div style={styles.overlay} />

      <section style={styles.card} aria-labelledby="maintenance-title">
        <div style={styles.iconWrapper} aria-hidden="true">
          &#128736;&#65039;
        </div>

        <p style={styles.status}>Scheduled maintenance</p>

        <h1 id="maintenance-title" style={styles.title}>
          We'll be back soon
        </h1>

        <p style={styles.message}>
          To improve your experience, scheduled system maintenance will take
          place on Wednesday, August 26, from 12:00 AM to 4:00 AM EST.
        </p>

        <div style={styles.schedule}>
          <span style={styles.scheduleIcon} aria-hidden="true">
            &#128336;
          </span>

          <div>
            <strong style={styles.scheduleTitle}>
              Maintenance window
            </strong>

            <span style={styles.scheduleTime}>
              August 12 &middot; 1:00 AM–4:00 AM EST
            </span>
          </div>
        </div>

        <p style={styles.subMessage}>
          Some services may be temporarily unavailable during this time. Thank
          you for your patience and understanding.
        </p>

        <button
          type="button"
          style={styles.button}
          onClick={() => window.location.reload()}
          onMouseEnter={(event) => {
            event.currentTarget.style.backgroundColor = "#154db3";
            event.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(event) => {
            event.currentTarget.style.backgroundColor = "#1d5fd1";
            event.currentTarget.style.transform = "translateY(0)";
          }}
        >
          Refresh page
        </button>
      </section>
    </main>
  );
};

const styles = {
  container: {
    position: "relative",
    minHeight: "100vh",
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "32px 20px",
    overflow: "hidden",
    backgroundColor: "#153b70",
    backgroundImage: "linear-gradient(135deg, #10254a, #2765ad)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    fontFamily:
      'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(135deg, rgba(8, 25, 55, 0.82), rgba(21, 73, 145, 0.62))",
  },

  card: {
    position: "relative",
    zIndex: 1,
    width: "100%",
    maxWidth: "560px",
    boxSizing: "border-box",
    padding: "48px 44px",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    borderRadius: "20px",
    background: "rgba(255, 255, 255, 0.96)",
    boxShadow: "0 24px 64px rgba(4, 18, 44, 0.28)",
    textAlign: "center",
  },

  iconWrapper: {
    width: "76px",
    height: "76px",
    margin: "0 auto 22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    background: "#edf4ff",
    fontSize: "36px",
  },

  status: {
    margin: "0 0 10px",
    color: "#1d5fd1",
    fontSize: "13px",
    fontWeight: 700,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
  },

  title: {
    margin: "0 0 18px",
    color: "#14213d",
    fontSize: "clamp(30px, 5vw, 40px)",
    fontWeight: 700,
    lineHeight: 1.15,
    letterSpacing: "-1px",
  },

  message: {
    margin: "0 0 24px",
    color: "#536079",
    fontSize: "17px",
    lineHeight: 1.7,
  },

  schedule: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    marginBottom: "24px",
    padding: "16px 18px",
    border: "1px solid #dbe7fa",
    borderRadius: "12px",
    background: "#f5f8fd",
    textAlign: "left",
  },

  scheduleIcon: {
    flexShrink: 0,
    fontSize: "25px",
  },

  scheduleTitle: {
    display: "block",
    marginBottom: "3px",
    color: "#24324a",
    fontSize: "14px",
  },

  scheduleTime: {
    display: "block",
    color: "#65718a",
    fontSize: "14px",
  },

  subMessage: {
    margin: "0 0 28px",
    color: "#6d778b",
    fontSize: "15px",
    lineHeight: 1.6,
  },

  button: {
    minWidth: "150px",
    padding: "13px 25px",
    border: "none",
    borderRadius: "9px",
    backgroundColor: "#1d5fd1",
    boxShadow: "0 8px 20px rgba(29, 95, 209, 0.25)",
    color: "#fff",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 650,
    transition:
      "background-color 160ms ease, transform 160ms ease, box-shadow 160ms ease",
  },
};

export default UnderMaintenance;